import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, DialogActions, DialogContent, Grid, MenuItem, Select, TextField } from "@material-ui/core";
import { useDialog } from "../Dialogs/DialogProvider";
import { days } from "../OpeningHours/WeekHours";
import TimePicker from "./TimePicker";
import { toast } from "react-toastify";

function MakeRuleDialog(props) {
  const [rule, setRule] = useState(props.rule);
  const [valid, setValid] = useState(false);

  const hours = [];
  for (let i = 0; i < 25; i++) {
    let hour = String(i);
    if (hour.length === 1) {
      hour = "0" + hour;
    }
    hours.push(hour);
  }
  const minutes = [];
  for (let i = 0; i < 4; i++) {
    let minute = String(i * 15);
    if (minute.length === 1) {
      minute = "0" + minute;
    }
    minutes.push(minute);
  }
  const [, closeDialog] = useDialog();

  const onChange = (key, value) => {
    setRule({ ...rule, [key]: value });
  };

  const isValid = () => {
    if (!rule.day) {
      return false;
    }
    let [fromHours, fromMinutes] = (rule.from ?? hours[0] + ":" + minutes[0]).split(":");
    let [toHours, toMinutes] = (rule.upto ?? hours[0] + ":" + minutes[0]).split(":");
    let fromTotalMinutes = parseInt(fromHours) * 60 + parseInt(fromMinutes);
    let toTotalMinutes = parseInt(toHours) * 60 + parseInt(toMinutes);
    return toTotalMinutes >= fromTotalMinutes;
  };

  useEffect(() => {
    let newRule = { ...rule };

    if (!rule.from) {
      newRule.from = hours[0] + ":" + minutes[0];
    }
    if (!rule.upto) {
      newRule.upto = hours[0] + ":" + minutes[0];
    }
    setRule(newRule);
  }, []);

  useEffect(() => {
    let newValid = isValid();
    if (!newValid && valid) {
      toast.warning("Time selection invalid", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setValid(isValid());
  }, [rule]);

  return (
    <>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            Day
          </Grid>
          <Grid item xs={6}>
            <Select
              value={rule.day}
              onChange={(e) => {
                onChange("day", e.target.value);
              }}
            >
              {days.map((day) => (
                <MenuItem value={day}>{day}</MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={4}>
            From time
          </Grid>
          <Grid item xs={8} container justify={"center"} alignItems={"center"}>
            <TimePicker
              onChange={(time) => {
                onChange("from", time);
              }}
              hours={hours}
              minutes={minutes}
              time={rule.from ?? hours[0] + ":" + minutes[0]}
            />
          </Grid>
          <Grid item xs={4}>
            Upto time
          </Grid>
          <Grid item xs={8} container justify={"center"} alignItems={"center"}>
            <TimePicker
              onChange={(time) => {
                onChange("upto", time);
              }}
              hours={hours}
              minutes={minutes}
              time={rule.upto ?? hours[0] + ":" + minutes[0]}
            />
          </Grid>
          <Grid item xs={4}>
            Max takeaway orders
          </Grid>
          <Grid item xs={8}>
            <TextField
              type={"number"}
              value={rule.takeaway}
              onChange={(e) => {
                let newValue = parseInt(e.target.value);
                if (typeof newValue !== "number" || isNaN(newValue)) {
                  newValue = null;
                }
                onChange("takeaway", newValue);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            Max delivery orders
          </Grid>
          <Grid item xs={8}>
            <TextField
              type={"number"}
              value={rule.delivery}
              onChange={(e) => {
                let newValue = parseInt(e.target.value);
                if (typeof newValue !== "number" || isNaN(newValue)) {
                  newValue = null;
                }
                onChange("delivery", newValue);
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {Object.keys(props.rule).length > 0 && (
          <Button
            onClick={() => {
              props.onSave(null);
              closeDialog();
            }}
          >
            Delete
          </Button>
        )}
        <Button
          onClick={() => {
            closeDialog();
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={!valid}
          onClick={() => {
            props.onSave(rule);
            closeDialog();
          }}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}

MakeRuleDialog.propTypes = {
  rule: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default MakeRuleDialog;
